import { render, staticRenderFns } from "./commonIndex.vue?vue&type=template&id=747352ca&scoped=true&lang=pug"
import script from "./commonIndex.vue?vue&type=script&lang=js"
export * from "./commonIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747352ca",
  null
  
)

export default component.exports